import React from 'react'
import GenericButton from '../GenericButton'
import { gettext } from 'ttag'

function getIcon (on: any) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (on) {
    return 'door'
  }

  return 'door-open'
}

interface OwnProps {
  children?: React.ReactNode
  onPress?: (...args: any[]) => any
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
type Props = OwnProps & typeof DoorSensor.defaultProps

// @ts-expect-error ts-migrate(2339) FIXME: Property 'onLongPress' does not exist on type 'Pro... Remove this comment to see the full error message
export default function DoorSensor ({ onPress, onLongPress, on, offline, text, connectionStatus, hide, hideButtonPress }: Props) {
  return (
    <GenericButton
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      icon={getIcon(!on)}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ icon: string; text: any; status: string; t... Remove this comment to see the full error message
      text={text}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      status={on ? gettext('Opened') : gettext('Closed')}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      textColor={on ? { color: '#ca6566', fontWeight: 'bold' } : null}
      on={on}
      offline={offline}
      onPress={onPress}
      onLongPress={onLongPress}
      connectionStatus={connectionStatus}
      hide={hide}
      hideButtonPress={hideButtonPress}
    />
  )
}

DoorSensor.defaultProps = {
  children: null,
  onPress: () => { }
}
